import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { app_permissions } from '../../security/app-permissions';
import { PermissionService } from '../../security/permission.service';

interface HrNavItem {
  label: string;
  icon: string;
  route: string;
  permission: string;
}

const HR_NAV_ITEMS: HrNavItem[] = [
  { label: 'Dashboard', icon: 'fa-solid fa-chart-line', route: '/hr', permission: app_permissions.hr.dashboard.view },
  { label: 'Employees', icon: 'fa-solid fa-users', route: '/hr/employees', permission: app_permissions.hr.employees.view },
  { label: 'Onboarding', icon: 'fa-solid fa-user-plus', route: '/hr/onboarding', permission: app_permissions.hr.onboarding.view },
  { label: 'Recruitment', icon: 'fa-solid fa-user-magnifying-glass', route: '/hr/recruitment', permission: app_permissions.hr.recruitment.view },
  { label: 'Learning', icon: 'fa-solid fa-graduation-cap', route: '/hr/learning', permission: app_permissions.hr.learning.view },
  { label: 'Performance', icon: 'fa-solid fa-chart-line', route: '/hr/performance', permission: app_permissions.hr.performance.view },
  { label: 'Cases', icon: 'fa-solid fa-briefcase', route: '/hr/cases', permission: app_permissions.hr.cases.view },
  { label: 'Analytics', icon: 'fa-solid fa-chart-pie', route: '/hr/analytics', permission: app_permissions.hr.analytics.view },
  { label: 'Annual Report', icon: 'fa-solid fa-table-columns', route: '/hr/analytics/annual-report', permission: app_permissions.hr.analytics.view },
  { label: 'Lifecycle', icon: 'fa-solid fa-arrows-rotate', route: '/hr/lifecycle', permission: app_permissions.hr.lifecycle.view },
  { label: 'Documents', icon: 'fa-solid fa-folder-open', route: '/hr/documents', permission: app_permissions.hr.documents.view },
  { label: 'Admin Ops', icon: 'fa-solid fa-building-shield', route: '/hr/admin-operations', permission: app_permissions.hr.adminOperations.view },
  { label: 'Types', icon: 'fa-solid fa-sliders', route: '/hr/documents/types', permission: app_permissions.hr.documentTypes.view },
  { label: 'Readiness', icon: 'fa-solid fa-clipboard-check', route: '/hr/readiness', permission: app_permissions.hr.readiness.view },
  { label: 'Leave', icon: 'fa-solid fa-calendar-days', route: '/hr/leave', permission: app_permissions.hr.leave.view },
  { label: 'Time', icon: 'fa-solid fa-business-time', route: '/hr/time', permission: app_permissions.hr.time.view },
  { label: 'Biometric', icon: 'fa-solid fa-fingerprint', route: '/hr/biometric', permission: app_permissions.hr.biometric.view },
  { label: 'Country Packs', icon: 'fa-solid fa-globe', route: '/hr/country-packs', permission: app_permissions.hr.countryPacks.view },
  { label: 'Roster', icon: 'fa-solid fa-calendar-week', route: '/hr/roster', permission: app_permissions.hr.roster.view },
  { label: 'Payroll', icon: 'fa-solid fa-file-invoice-dollar', route: '/hr/payroll', permission: app_permissions.hr.payroll.view },
  { label: 'Setup', icon: 'fa-solid fa-sitemap', route: '/hr/setup', permission: app_permissions.hr.org.view },
  { label: 'Migration', icon: 'fa-solid fa-code-merge', route: '/hr/migration', permission: app_permissions.hr.migration.view }
];

@Component({
  selector: 'app-hr-module-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, ButtonModule],
  templateUrl: './hr-module-nav.component.html',
  styleUrls: ['./hr-module-nav.component.scss']
})
export class HrModuleNavComponent {
  private readonly permissionService = inject(PermissionService);

  @Input() activeRoute = '/hr';

  readonly visibleItems = HR_NAV_ITEMS.filter(item =>
    this.permissionService.hasPermission(item.permission, item.route === '/hr' ? 'ANY' : undefined)
  );
}
